import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import classNames from 'classnames';
import _ from 'lodash';
import s from './FAQModule.module.scss';

const FAQModule = ({ title = '', text = '', items = [], link = {}, isRekAI = false }) => {

    const classes = classNames(
        s['FAQModule'],
        { [s['FAQModule--Accordion']]: isRekAI },
        { [s['FAQModule--Links']]: !isRekAI },
    );

    return (
        <div className={classes}>
            <div className={s['FAQModule__Wrap']}>
                <div className={s['FAQModule__Header']}>
                    <h2 className={s['FAQModule__Title']}>{title}</h2>

                    {!_.isEmpty(link) &&
                        <Link {...link} />
                    }

                    {text &&
                        <div className={s['FAQModule__Text']}>
                            {text}
                        </div>
                    }
                </div>

                {isRekAI ? (
                    <div className={s['FAQModule__List']}>
                        {items.map((item, index) => (
                            <article
                                key={index}
                                className={s['FAQModule__Item']}
                            >
                                <Details {...item} />
                            </article>
                        ))}
                    </div>
                ) : (
                    <ul className={s['FAQModule__List']}>
                        {items.map((item, index) => (
                            <li
                                key={index}
                                className={s['FAQModule__Item']}
                            >
                                <Link {...item} target="_blank" />
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
};

FAQModule.propTypes = {
    title: PropTypes.string.isRequired,
    text: PropTypes.string,
    items: PropTypes.array.isRequired,
    link: PropTypes.object,
    isRekAI: PropTypes.bool,
};

const Details = ({ question = '', answer  = '', url = '', pagetitle = '' }) => {
    const { t } = useTranslation();

    return (
        <details className={[s['FAQModule__Button']]}>
            <summary className={s['FAQModule__Question']}>{question}</summary>
            <p className={s['FAQModule__Answer']}>
                {answer}
                {url && (
                    <a
                        className={s['FAQModule__ReadMore']}
                        href={url}
                    >
                        {t('faqModule.readMore', { title: pagetitle })}
                    </a>
                )}
            </p>
        </details>
    );
};

Details.propTypes = {
    question: PropTypes.string,
    answer: PropTypes.string,
    url: PropTypes.string,
    pagetitle: PropTypes.string,
};

const Link = ({ url = '', title = '', target = '' }) => {
    return (
        <a
            className={s['FAQModule__Link']}
            href={url}
            target={target}
            rel="noreferrer noopener"
        >{title}</a>
    );
};

Link.propTypes = {
    title: PropTypes.string.isRequired,
    url: PropTypes.string,
    target: PropTypes.string,
};

export default FAQModule;
